import { Icon, StyledTitle } from '../../common/components';
import { CircleCheckThin, WarningTriangleRed, WarningTriangleYellow } from '../icons';
import { HealthCheckStatusHeaderWrapper } from './HealthCheckStatusStyles';

type HealthCheckStatusHeaderProps = {
  healthyCount: number;
  degradedCount: number;
  unhealthyCount: number;
  lastChecked: string;
};

const defaultProps = {
  healthyCount: 0,
  degradedCount: 0,
  unhealthyCount: 0,
  lastChecked: 'Loading',
};

export const HealthCheckStatusHeader = (props: HealthCheckStatusHeaderProps) => {
  return (
    <HealthCheckStatusHeaderWrapper>
      <div className='row mb-4'>
        <div className='col-md-6 mb-4 mt-4 filter'>
          <StyledTitle>Health check</StyledTitle>
          <div>Last checked: {props.lastChecked}</div>
          <div className='d-flex'></div>
        </div>
        <div className='col-md-6 mb-4 mt-4 filter'>
          <div className='statusCount'>
            <div className='pr-3'>
              <Icon className={'mr-1'} size={25} icon={CircleCheckThin} />
              {`${props.healthyCount} Healthy`}
            </div>
            <div className='pr-3'>
              <Icon className={'mr-1'} size={25} icon={WarningTriangleYellow} />
              {`${props.degradedCount} Degraded`}
            </div>
            <div>
              <Icon className={'mr-1'} size={25} icon={WarningTriangleRed} />
              {`${props.unhealthyCount} Unhealthy`}
            </div>
          </div>
        </div>
      </div>
    </HealthCheckStatusHeaderWrapper>
  );
};

HealthCheckStatusHeader.defaultProps = defaultProps;

export default HealthCheckStatusHeader;
